<template>
  <div class="nch--blog-comment--container" :class={children}>
    <div class="nch--blog-comment">
      <div class="nch--blog-comment_avatar" :style="{backgroundImage: `url(${picture})`}"></div>
      <div class="nch--blog-comment_content">
        <span class="nickname">{{ comment.author.name }}</span>
        <p class="content">{{ comment.content }}</p>
      </div>
      <div class="rating" v-if="!children">
        <button
          class="replies"
          @click="loadReplies"
          :title="comment.replies_count
            ? $t('blog.comments.show_replies')
            : $t('blog.comments.no_replies')"
          :disabled="!comment.replies_count"
        >
          {{ `${comment.replies_count || 0} ${$t('blog.comments.replies')}` }}
        </button>
      </div>
      <div class="actions" v-if="user && !children && !reply">
        <button
          :title="$t('blog.comments.reply')"
          @click="reply = true"
        >{{ $t('blog.comments.reply') }}</button>
      </div>
    </div>
    <div class="nch--blog-replies">
      <Comment
        v-for="reply in replies"
        :key="reply.id"
        :value="reply"
        :user="user"
        children
      />
      <Reply v-if="reply" :parent="comment" @saved="pushReply"/>
    </div>
  </div>
</template>

<script>
import Card from '../../../common/Card';
import Reply from './Reply';

export default {
  name: 'Comment',
  components: {
    Card,
    Reply,
  },
  props: {
    user: {
      type: Object,
      description: 'Auth user',
    },
    value: {
      type: Object,
      description: 'Comment object',
    },
    children: {
      type: Boolean,
      description: 'is comment children',
    },
  },
  data: () => ({
    reply: false,
    replies: [],
  }),
  computed: {
    comment() {
      return this.value;
    },
    picture() {
      try {
        return this.getImageUrl(this.comment.author.photo);
      } catch (e) {
        return '/img/profile.png';
      }
    },
  },
  methods: {
    pushReply(comment) {
      this.replies.push(comment);
      this.comment.replies_count += 1;
      this.reply = false;
    },
    getImageUrl(upload) {
      const { host, original_file: file } = upload;
      return `/storage/${host}/original/${file}`;
    },
    async loadReplies() {
      const { data } = await window.axios
        .get(`/api/blog/comments/${this.comment.id}/list`, {
          params: {
            per_page: this.comment.replies_count,
          },
        });
      this.replies = data.data;
    },
  },
};
</script>

<style scoped>
.nch--blog-comment--container{
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 1rem 0
}
.nch--blog-comment--container.children {
  width: 95%;
  align-self: flex-end;
  margin: .2rem 0;
}

.nch--blog-comment {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  grid-template-areas:
    "avatar content content"
    "_ rating actions";
}

.nch--blog-comment_avatar {
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  display: flex;
  align-self: flex-start;
  padding: 5px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  background-color: transparent;
}
.nch--blog-comment_content {
  grid-area: content;
  font-size: 0.9rem;
  padding: 0 1rem;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.nch--blog-comment_content .nickname{
  font-weight: 600;
}
.nch--blog-comment_content .content{
  margin-bottom: .2rem;
  line-height: 1.2;
  flex-wrap: wrap;
  word-break: break-all;
}
.nch--blog-comment .rating {
  grid-area: rating;
  padding: 0 1rem;
}
.nch--blog-comment .actions {
  grid-area: actions;
  display: flex;
  justify-content: flex-end;
}
.nch--blog-comment .replies {
  border: none;
  font-size: .7rem;
  color: var(--blog-text);
  background-color: transparent;
}
.nch--blog-comment .replies[disabled]{
  cursor: default;
}

.nch--blog-comment .actions button {
  padding: 0.1rem;
  border: none;
  background-color: transparent;
  color: var(--blog-text);
}
.nch--blog-replies{
  margin-left: 1rem;
  padding-left: .5rem;
  border-left: 1px solid #e8e8e8;
}
</style>
